import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import axios from "axios";

const AdminAuthContext = createContext(null);
const TOKEN_KEY = "asc_admin_token";

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) { setLoading(false); return; }
    adminApi.get("/admin/me")
      .then(({ data }) => setAdmin(data))
      .catch(() => localStorage.removeItem(TOKEN_KEY))
      .finally(() => setLoading(false));
  }, []);

  const login = async (code) => {
    const { data } = await api.post("/admin/login", { code });
    localStorage.setItem(TOKEN_KEY, data.token);
    const me = await adminApi.get("/admin/me");
    setAdmin(me.data);
    return data;
  };

  const logout = async () => {
    try { await adminApi.post("/admin/logout"); } catch {}
    localStorage.removeItem(TOKEN_KEY);
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);

// Dedicated axios instance using the admin token
export const adminApi = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL + "/api" });
adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith("/admin/")) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/admin";
    }
    return Promise.reject(err);
  }
);
